import React, { useEffect, useRef, useState } from "react";
import InnerBanner from "../components/InnerBanner";
import AboutSection from "../components/AboutSection";
import AboutFeature from "../components/AboutFeature";
import Header from "../components/Header";
import { dashboard } from "../handler/LoginAndSingupHandler";

const ContactPage: React.FC = () => {
  const [statistics, setStatistics] = useState({
    students: 0,
    courses: 0,
    teachers: 0,
    awards: 0,
  });

  const runOnce = useRef(false);

  const dashboardApi = async () => {
    try {
      const response = await dashboard();

      if (response.statusCode === 200) {
        setStatistics(response.data.dashboard.statistics);
      }
    } catch (error) {
      console.error("Dashboard API error:", error);
    }
  };

  useEffect(() => {
    if (!runOnce.current) {
      runOnce.current = true;
      dashboardApi();
    }
  }, []);

  return (
    <>
      {/* =====================================================
          GLOBAL MOBILE SAFE STYLE
      ====================================================== */}
      <style>
        {`
          html,
          body,
          #root {
            width: 100%;
            min-width: 0;
            margin: 0;
            padding: 0;
            overflow-x: hidden;
          }

          * {
            box-sizing: border-box;
          }

          .about-page {
            width: 100%;
            min-height: 100vh;
            background: #000000;
            color: #ffffff;
            overflow-x: hidden;
            overflow-y: visible;
          }

          .about-section {
            width: 100%;
            min-width: 0;
            position: relative;
            overflow: hidden;
          }

          .about-content {
            width: 100%;
            max-width: 100%;
            min-width: 0;
            position: relative;
            z-index: 2;
          }

          .background-glow {
            pointer-events: none;
            max-width: 100vw;
          }

          @media (max-width: 768px) {
            .about-page {
              width: 100%;
              min-width: 0;
              overflow-x: hidden;
            }

            .about-section {
              width: 100%;
              min-width: 0;
              overflow: hidden;
            }

            .about-content {
              width: 100%;
              min-width: 0;
              padding-left: 0;
              padding-right: 0;
            }

            .background-glow {
              width: 180px !important;
              height: 180px !important;
              filter: blur(70px) !important;
            }
          }

          @media (max-width: 480px) {
            .background-glow {
              width: 140px !important;
              height: 140px !important;
            }
          }
        `}
      </style>

      <div className="about-page">

        {/* =====================================================
            HEADER
        ====================================================== */}
        <Header />

        {/* =====================================================
            INNER BANNER
        ====================================================== */}
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflow: "hidden",
          }}
        >
          <InnerBanner pageName="About Us" />
        </div>

        {/* =====================================================
            ABOUT / STATISTICS
        ====================================================== */}
        <section
          className="about-section"
          style={{
            background:
              "linear-gradient(180deg, #020303 0%, #05070b 100%)",
          }}
        >
          {/* Background grid */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              opacity: 0.06,
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",
              backgroundSize: "32px 32px",
            }}
          />

          {/* Cyan glow */}
          <div
            className="background-glow"
            style={{
              position: "absolute",
              width: "300px",
              height: "300px",
              left: "-150px",
              top: "50px",
              borderRadius: "50%",
              background: "rgba(0,246,255,0.06)",
              filter: "blur(100px)",
              pointerEvents: "none",
            }}
          />

          {/* Purple glow */}
          <div
            className="background-glow"
            style={{
              position: "absolute",
              width: "300px",
              height: "300px",
              right: "-150px",
              bottom: "50px",
              borderRadius: "50%",
              background: "rgba(139,92,255,0.06)",
              filter: "blur(100px)",
              pointerEvents: "none",
            }}
          />

          <div className="about-content">
            <AboutSection
              statistics={{
                students: statistics.students + 1000,
                courses: statistics.courses,
                teachers: statistics.teachers,
                awards: statistics.awards,
              }}
            />
          </div>
        </section>

        {/* =====================================================
            ABOUT FEATURE
        ====================================================== */}
        <section
          className="about-section"
          style={{
            background: "#000000",
            borderTop: "1px solid rgba(0,246,255,0.08)",
          }}
        >
          {/* Background grid */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              opacity: 0.045,
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)",
              backgroundSize: "32px 32px",
            }}
          />

          <div className="about-content">
            <AboutFeature />
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactPage;